import React from 'react'
import './Footer.css';
import { Link } from 'react-router-dom';
import frameImg from '../../assets/Frame22222.svg'
import trustFrame from '../../assets/trustFrame.webp'

function Footer() {
    return (
        <div className='footer-container'>
            <div className="footer-images-column">
                <img
                    src={trustFrame}
                    alt="trust"
                    className='trust-img'
                />
                <img
                    src={frameImg}
                    alt="frame"
                    className='frame-img'
                />
            </div>

            <div className="links">
                <div className="tata-market">
                    <h5>Tata Market Place</h5>
                    <div className="tata-market-links">
                        <Link to='#'>About Us</Link>
                        <Link to='#'>Careers</Link>
                        <Link to='#'>Terms of Use</Link>
                        <Link to='#'>Privacy Policy</Link>
                        <Link to='#'>Affiliates</Link>
                        <Link to='#'>Sitemap</Link>
                    </div>
                </div>

                <div className="customer-service">
                    <h5>Customer Service</h5>
                    <div className="customer-service-links">
                        {/* <Link to='https://www.tatacliq.com/shopping-faq'>Shopping</Link> */}
                        <a href="https://www.tatacliq.com/shopping-faq" target="_blank" rel="noopener noreferrer">
                            Shopping
                        </a>
                        <Link to='#'>Offers & Promotions</Link>
                        <Link to='#'>Payments</Link>
                        <Link to='#'>Cancellation</Link>
                        <Link to='#'>Returns & Refunds</Link>
                        <Link to='#'>CliQ And PiQ</Link>
                        <Link to='#'>Return Policy</Link>
                        <Link to='#'>Electronics Return Policy</Link>
                        <Link to='#'>Contact Us</Link>
                        <Link to='#'>Reviews Guidlines</Link>
                        <Link to='#'>Furnitures Return Policy</Link>
                        <Link to='#'>Replcement Policy</Link>
                    </div>
                </div>

                <div className="my-tata">
                    <h5>My Tata CLiQ</h5>
                    <div className="my-tata-links">
                        <Link to='/my-account'>My Account</Link>
                        <Link to='/track-order'>My Orders</Link>
                        <Link to='/cart'>My Shopping Bag</Link>
                        <Link to='/wishlist'>My Wishlist</Link>
                    </div>
                </div>

                <div className="tata-offering">
                    <h5>Tata CLiQ Offerings</h5>
                    <div className="tata-offering-links">
                        <div className="tata-offering-links-first-row">
                            <Link to='#'>Watches for Men </Link>
                            | <Link to='#'>Campus Shoes </Link>
                            | <Link to='#'>Sandals for Men </Link>
                            | <Link to='#'>Sneakers for Men</Link>
                        </div>
                        <div className="tata-offering-links-second-row">
                            <Link to='#'>Reebok Shoes </Link>
                            | <Link to='#'>Cotton Kurtis </Link>
                            | <Link to='#'>Woodland Shoes </Link>
                            | <Link to='#'>Jumpsuits </Link>
                            | <Link to='#'>Allen Solly </Link>
                        </div>
                        <div className="tata-offering-links-third-row">
                            <Link to='#'>Sparx Shoes </Link>
                            | <Link to='#'>Gold Rings </Link>
                            | <Link to='#'>Formal Shoes for Men </Link>
                            | <Link to='#'>Sports Shoes for Men </Link>
                        </div>
                        <div className="tata-offering-links-fourth-row">
                            <Link to='#'>Wallets for Men </Link>
                            | <Link to='#'>Ladies Watches </Link>
                            | <Link to='#'>Trolley Bags </Link>
                            | <Link to='#'>Handbags for Women</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer